import script from "./Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Status.vue?vue&type=script&setup=true&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=25aa517a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25aa517a"]])

export default __exports__